import { Controller } from '@hotwired/stimulus';

// Adhésions d'un membre (posé sur le formulaire) : rôles
// libres du client choisi (chargés en paires), ajout d'un client à la liste
// (modèle <template>, champs cachés numérotés), retrait ; client absent ou déjà
// présent : message, rien d'ajouté ; client et rôle choisis sans « Ajouter »
// au moment de l'envoi : adhésion ajoutée à l'envoi ; liste vidée :
// user[memberships_empty] envoyé.
export default class extends Controller {
    static targets = ['customer', 'role', 'list', 'template', 'notice'];
    static values = { rolesUrl: String, userId: Number };

    // Numéros des adhésions ajoutées : à partir de l'heure, jamais repris
    // (page revenue du cache Turbo avec des ajouts déjà numérotés).
    connect() {
        this.count = Date.now();
    }

    async loadRoles() {
        const customer = this.customerTarget.value;
        if (!customer) return;
        const query = new URLSearchParams({ customer_id: customer, user_id: this.userIdValue, pairs: 1 });
        const response = await fetch(`${this.rolesUrlValue}?${query}`, { headers: { Accept: 'application/json' } });
        if (!response.ok || customer !== this.customerTarget.value) return;
        const roles = await response.json();
        this.roleTarget.replaceChildren(...roles.map(([label, value]) => new Option(label, value)));
        this.roleTarget.dispatchEvent(new CustomEvent('combobox:render', { bubbles: true }));
    }

    add() {
        const customer = this.customerTarget.selectedOptions[0];
        const role = this.roleTarget.selectedOptions[0];
        if (!customer || !customer.value) {
            this.notify('Choisissez un client.');
            return;
        }
        if (this.listTarget.querySelector(`[data-customer-id="${CSS.escape(customer.value)}"]`)) {
            this.notify(`Ce membre a déjà un rôle dans ${customer.text}.`);
            return;
        }
        this.notify('');
        const item = this.templateTarget.content.firstElementChild.cloneNode(true);
        const prefix = `user[memberships_attributes][${this.count}]`;
        item.dataset.customerId = customer.value;
        item.querySelector('[data-field="customer"]').textContent = customer.text;
        item.querySelector('[data-field="role"]').textContent = role ? role.text : '';
        Object.assign(item.querySelector('[data-field="customer_id"]'), { name: `${prefix}[customer_id]`, value: customer.value });
        Object.assign(item.querySelector('[data-field="role_value"]'), { name: `${prefix}[role]`, value: role ? role.value : '' });
        const remove = item.querySelector('button');
        remove.title = `Retirer ${customer.text}`;
        remove.setAttribute('aria-label', remove.title);
        this.listTarget.append(item);
        this.count += 1;
        // Choix vidés : la ligne ajoutée n'est pas reprise à l'envoi.
        this.customerTarget.dispatchEvent(new CustomEvent('combobox:clear', { bubbles: true }));
        this.roleTarget.dispatchEvent(new CustomEvent('combobox:clear', { bubbles: true }));
    }

    remove({ currentTarget }) {
        currentTarget.closest('[data-customer-id]').remove();
    }

    // Envoi réel (après la vérification) : ligne entamée ajoutée ; liste
    // vide, le serveur doit le savoir.
    submit({ formData }) {
        const customer = this.customerTarget.value;
        const role = this.roleTarget.value;
        if (customer && role && !this.listTarget.querySelector(`[data-customer-id="${CSS.escape(customer)}"]`)) {
            const prefix = `user[memberships_attributes][${this.count}]`;
            formData.append(`${prefix}[customer_id]`, customer);
            formData.append(`${prefix}[role]`, role);
            this.count += 1;
            return;
        }
        if (this.listTarget.children.length === 0) formData.append('user[memberships_empty]', 'true');
    }

    notify(message) {
        this.noticeTarget.textContent = message;
        this.noticeTarget.hidden = message === '';
    }
}
